import { Component } from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import classnames from 'classnames'
import Hammer from 'hammerjs'
import tinycolor from 'tinycolor2'
import { ThemeContext } from '../../../../base/ThemeContext'

export default class Handle extends Component {
  constructor(props) {
    super(props)
    this._hammerManager = null
  }

  componentDidMount() {
    this._hammertime()
  }

  componentWillUnmount() {
    this._stopHammertime()
  }

  handlePanStart = hammerEvent => {
    this.props.onPanStart(hammerEvent, this.props.handle)
  }

  handlePanMove = hammerEvent => {
    this.props.onPanMove(hammerEvent, this.props.handle)
  }

  handlePanEnd = hammerEvent => {
    this.props.onPanEnd(hammerEvent, this.props.handle)
  }

  _hammertime() {
    if (!this._hammerManager) {
      this._hammerManager = new Hammer.Manager(ReactDOM.findDOMNode(this), {
        recognizers: [[Hammer.Pan, { threshold: 0, direction: Hammer.DIRECTION_HORIZONTAL }]],
      })
    }
    this._hammerManager.on('panstart', this.handlePanStart)
    this._hammerManager.on('panmove', this.handlePanMove)
    this._hammerManager.on('panend', this.handlePanEnd)
  }

  _stopHammertime() {
    if (this._hammerManager) {
      this._hammerManager.off('panstart')
      this._hammerManager.off('panmove')
      this._hammerManager.off('panend')
      this._hammerManager.destroy()
      this._hammerManager = null
    }
  }

  render() {
    const { x, y, width, height, handle, cursor } = this.props
    const colorScheme = this.context
    const borderWidth = 1

    let tinyColor = tinycolor(colorScheme.primary)
    const handleBackgroundColor = tinyColor.isLight()
      ? tinyColor.darken(7).toHexString()
      : tinyColor.lighten(7).toHexString()
    tinyColor = tinycolor(colorScheme.highlight)
    const borderColor = colorScheme.highlight //tinyColor.isLight() ? tinyColor.saturate(20).toHexString() : tinyColor.desaturate(20).toHexString()

    const handleStyle = {
      top: y,
      left: x,
      width: width,
      height: height,
      marginTop: (height / 2) * -1,
      marginLeft: (width / 2) * -1,
      backgroundColor: handleBackgroundColor,
      borderColor: borderColor,
      cursor: cursor,
    }
    const gripStyle = {
      height: Math.round(height * 0.4),
      backgroundColor: borderColor,
    }
    const className = classnames('handle', `handle--${handle}`)
    return (
      <div className={className} data-handle={handle} style={handleStyle}>
        <div className="gripper">
          <div className="grip" style={gripStyle}></div>
          <div className="grip" style={gripStyle}></div>
          <div className="grip" style={gripStyle}></div>
        </div>
      </div>
    )
  }
}
Handle.contextType = ThemeContext
Handle.propTypes = {
  handle: PropTypes.string.isRequired,
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  cursor: PropTypes.string,
}
Handle.defaultProps = {
  cursor: 'auto',
}
